import React, { useState, useEffect } from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, 
  TableRow, TablePagination, Paper, Button, TextField, 
  Box, MenuItem, Select, InputLabel, FormControl 
} from '@mui/material';
import amexTransactions from '../services/amex_transactions.service';

export default function BillingStatementPage() {
  const [cardFiles, setCardFiles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [orderBy, setOrderBy] = useState('date');
  const [orderDirection, setOrderDirection] = useState('asc');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [fileFormat, setFileFormat] = useState('excel'); // New state for file format

  useEffect(() => {
    fetchCardFiles(page + 1, rowsPerPage, keyword, orderBy, orderDirection, startDate, endDate, fileFormat);
  }, [page, rowsPerPage, keyword, orderBy, orderDirection, startDate, endDate, fileFormat]);

  const fetchCardFiles = async (page, pageSize, keyword, orderBy, orderDirection, startDate, endDate, format) => {
    try {
      const response = await amexTransactions.getCardFiles(page, pageSize, keyword, orderBy, orderDirection, startDate, endDate, format);
      if (response.success) {
        setCardFiles(response.result);
        setTotalCount(response.maxData);
      } else {
        console.error("Error fetching card files:", response.message);
      }
    } catch (error) {
      console.error("Failed to fetch card files:", error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
    setPage(0);
  };

  const handleOrderByChange = (newOrderBy) => {
    const newDirection = orderBy === newOrderBy && orderDirection === 'asc' ? 'desc' : 'asc';
    setOrderBy(newOrderBy);
    setOrderDirection(newDirection);
    setPage(0);
  };

  const handleDownload = (cardNo, fileName) => {
    amexTransactions.downloadFile(cardNo, fileName);
  };

  const handleFormatChange = (event) => {
    setFileFormat(event.target.value);  // Update file format
    setPage(0);  // Reset to first page when format changes
  };

  return (
    <div style={{ marginTop: "20px", width: "80%", margin: "auto" }}>
      <h1>BILLING STATEMENT MANAGER</h1>
      <Box mb={2} display="flex" alignItems="center">
        <TextField
          label="Search"
          variant="outlined"
          value={keyword}
          onChange={handleKeywordChange}
          style={{ marginRight: 8 }}
        />
        <FormControl variant="outlined" style={{ minWidth: 120, marginLeft: 8 }}>
          <InputLabel id="order-by-label">Order By</InputLabel>
          <Select
            labelId="order-by-label"
            value={orderBy}
            onChange={(event) => handleOrderByChange(event.target.value)}
            label="Order By"
          >
            <MenuItem value="date">Date</MenuItem>
            <MenuItem value="cardNo">Card Number</MenuItem>
            <MenuItem value="username">Username</MenuItem>
          </Select>
        </FormControl>
        <TextField
          type="date"
          label="Start Date"
          variant="outlined"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{ marginLeft: 8 }}
        />
        <TextField
          type="date"
          label="End Date"
          variant="outlined"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ marginLeft: 8 }}
        />
        {/* File Format Dropdown */}
        <FormControl variant="outlined" style={{ minWidth: 120, marginLeft: 8 }}>
          <InputLabel id="file-format-label">File Format</InputLabel>
          <Select
            labelId="file-format-label"
            value={fileFormat}
            onChange={handleFormatChange}
            label="File Format"
          >
            <MenuItem value="excel">Excel</MenuItem>
            <MenuItem value="csv">CSV</MenuItem>
            <MenuItem value="pdf">PDF</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell onClick={() => handleOrderByChange('date')} style={{ cursor: 'pointer' }}>
                Date {orderBy === 'date' ? (orderDirection === 'asc' ? '▲' : '▼') : ''}
              </TableCell>
              <TableCell onClick={() => handleOrderByChange('cardNo')} style={{ cursor: 'pointer' }}>
                Card Number {orderBy === 'cardNo' ? (orderDirection === 'asc' ? '▲' : '▼') : ''}
              </TableCell>
              <TableCell onClick={() => handleOrderByChange('username')} style={{ cursor: 'pointer' }}>
                Username {orderBy === 'username' ? (orderDirection === 'asc' ? '▲' : '▼') : ''}
              </TableCell>
              <TableCell>Download</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cardFiles.map((file) => (
              <TableRow key={file.downloadLink}>
                <TableCell>{file.date}</TableCell>
                <TableCell>{file.cardNo}</TableCell>
                <TableCell>{file.username}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleDownload(file.cardNo, file.downloadLink.split('/').pop())}
                  >
                    Download
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
}
